export default {"src":"/_next/static/media/sign-back-in-hero.5b89cd6e.svg","height":182,"width":288,"blurWidth":0,"blurHeight":0};